import React from 'react'
 
export const SectionPc = () => {


    return (
        <div className="sectionpc">
            <div className="introduce">
                <h1 className="title"> Multipurpose Listing Template with great landing pages </h1>
                <p className="description">
                Responsive & cross platform browser compatible components! 
                Also can be use as Real Estate, Hotel Booking, Travel, Listing Directory.
                </p>
                <div className="store">
                    <div className="app">Learn more</div>
                </div>
            </div>
            <div>
                {/**  <img src="/bg/wave3.svg" className="wave" draggable="false" /> */}
                <img src="/assets/images/bg/pc.png" className="cover" height='500' draggable="false" alt="" />
            </div>
       </div>
    )
} 